// extracted by mini-css-extract-plugin
export default {"preview-mode-tabs":"l0asYbCK","previewModeTabs":"l0asYbCK","tab-icon":"cmcmTV5t","tabIcon":"cmcmTV5t","selected":"aMHfrfLO","bluish":"rO6jnIU7"};